import { Input } from "antd";
import React from "react";
import ReactInputMask from "react-input-mask";

const InputMask = (props) => {
  return (
    <ReactInputMask {...props}>
      {(inputProps) => <Input {...inputProps} disabled={props?.disabled ?? null} />}
    </ReactInputMask>
  );
};

export default InputMask;
